import { faz } from './BasicoApi'

export const obter = id => {

    return new Promise((resolve,reject) => {
        faz("/dados/fotocopia/obterPorId", JSON.stringify({ id }))
        .then( resposta => resolve(resposta))
        .catch( erro => reject(erro))    
    })
}

export const adicionar = fotocopia => {

    return new Promise((resolve,reject) => {
        faz("/dados/fotocopia/adicionar", JSON.stringify({ fotocopia }))
        .then( resposta => resolve(resposta))
        .catch( erro => reject(erro))    
    })
}